import { parseAuthToken } from '../parseAuthToken'

export const isAuthTokenExpired = (token: string | null) => {
  const decodedToken = parseAuthToken(token)

  return decodedToken === null || new Date(Number(decodedToken.exp) * 1000) <= new Date()
}
